// extracted by mini-css-extract-plugin
export var buttons = "how-it-works-module--buttons--76540";
export var image = "how-it-works-module--image--8612e";
export var item = "how-it-works-module--item--64bcd";
export var list = "how-it-works-module--list--730fa";
export var section = "how-it-works-module--section--7e42a";
export var tab = "how-it-works-module--tab--23824";
export var tabs = "how-it-works-module--tabs--0914e";
export var text = "how-it-works-module--text--8c587";
export var topbuttons = "how-it-works-module--topbuttons--5652c";
export var videoButton = "how-it-works-module--videoButton--c1e98";